import { useEffect, useState } from 'react'
import useFirstRender from '../../hooks/FirstRender';
import LoadMore from '../../components/common/LoadMore';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useApiProgress } from '../../hooks/ApiProgress';
import { ENTITY_IS_IN_USE_MESSAGE } from '../../utils/constants';
import { toast } from 'react-toastify';
import Input from '../../components/Input';
import { AiFillDelete, AiFillEdit } from 'react-icons/ai';
import Button from '../../components/Button';
import { GoPlus } from 'react-icons/go';
import DeleteModal from '../../components/DeleteModal';
import { pageModel } from '../../utils/model';
import { setChequeSearchParamsAction } from '../../redux/feature/searchParamsSlice';
import { CHEQUE_PATH, deleteCheque, getPageCheques } from '../../api/chequeApi';
import { formatDate, formatNumber } from '../../utils/functions';

const ChequeListPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const isFirstRender = useFirstRender()
    const nav = useNavigate()
    const dispatch = useDispatch()
    const [chequePage, setChequePage] = useState(pageModel)
    const pendingApiCall = useApiProgress('get', `${CHEQUE_PATH}/page`, false)
    const pendingApiCallDelete = useApiProgress('delete', `${CHEQUE_PATH}`, false)
    const searchParams = useSelector(state => state.searchParams.cheque)
    const [isOpen, setIsOpen] = useState(false)
    const [deleteId, setDeleteId] = useState(undefined)
    const [searchTimer, setSearchTimer] = useState();

    useEffect(() => {
        loadCheques({ size: 20, page: chequePage.number, ...searchParams })
    }, [])

    const onLoadMore = () => {
        if (!chequePage.last) {
            loadCheques({ ...searchParams, lastId: chequePage.content[chequePage.content.length - 1]?.id })
        }
    }

    useEffect(() => {
        !isFirstRender && searching({ ...searchParams, page: 0 })
    }, [searchParams])

    const loadCheques = (params) => {
        !pendingApiCall &&
            getPageCheques(params)
                .then(res => {
                    setChequePage(prevState => ({ ...res.data, content: [...prevState.content, ...res.data.content] }))
                })
    }

    const searching = async (params) => {
        if (searchTimer) clearTimeout(searchTimer);
        let timer = setTimeout(() => {
            getPageCheques(params)
                .then(res => {
                    setChequePage(res.data)
                })
        }, 500);
        setSearchTimer(timer);
    }

    const onClickDelete = () => {
        deleteCheque(deleteId)
            .then(res => {
                setIsOpen(false)
                setChequePage(prevState => ({ ...prevState, content: prevState.content.filter(p => p.id !== deleteId) }))
                toast.success('Silindi')
            }).catch(err => {
                toast.error(ENTITY_IS_IN_USE_MESSAGE)
            })
    }

    return (
        <div>
            <div className='mb-1 border-b border-zinc-300'>
                <label className='text-2xl'>
                    ÇEKLER
                </label>
            </div>
            <div className='flex gap-x-2 py-2 sticky top-0 bg-zinc-50'>
                <Button
                    text={<label className='flex items-center gap-x-1'><GoPlus />Yeni Çek</label>}
                    variant='green'
                    onClick={() => nav('/cheque/add')}
                />
            </div>
            <div className='flex gap-x-2 mb-3'>
                <input
                    type='checkbox'
                    id='isEnabled'
                    onChange={e => dispatch(setChequeSearchParamsAction({ key: "isEnabled", value: !e.target.checked }))}
                />
                <label htmlFor='isEnabled'>Gönderilenleri göster</label>

            </div>
            <table className='w-full text-left text-zinc-900 mb-10 text-sm'>
                <thead className='text-xs uppercase tracking-wide sticky top-12 bg-zinc-50'>
                    <tr>
                        <th className='p-2 w-1/12'>Id</th>
                        <th className='p-2 w-2/12'>Çek Sahibi</th>
                        <th className='p-2 w-2/12'>Miktar</th>
                        <th className='p-2 w-2/12'>Son tarih</th>
                        <th className='p-2 w-2/12'>Çek Numarası</th>
                        <th className='p-2 w-2/12'>Gönderilen</th>
                        <th className='p-2 w-1/12'>Aksiyon</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className='border-b items-center sticky top-20 bg-zinc-50'>
                        <td className='px-2'>
                            <Input
                                name="id"
                                placeholder='Id...'
                                value={searchParams.id}
                                onChange={e => dispatch(setChequeSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                            />
                        </td>
                        <td className='px-2'>
                            <Input
                                name="owner"
                                placeholder='Çek sahibi...'
                                value={searchParams.owner}
                                onChange={e => dispatch(setChequeSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                            />
                        </td>
                        <td></td>
                        <td></td>
                        <td className='px-2'>
                            <Input
                                name="serialNumber"
                                placeholder='Çek numarası...'
                                value={searchParams.serialNumber}
                                onChange={e => dispatch(setChequeSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                            />
                        </td>
                    </tr>
                    {
                        chequePage.content.map((cheque, index) => (
                            <tr key={cheque.id} className='border-b items-center hover:bg-violet-100 duration-150'>
                                <td className='p-2'># {cheque.id} </td>
                                <td className='p-2'>{cheque.owner} </td>
                                <td className='p-2'>{formatNumber(cheque.amount)} {cheque.currency}</td>
                                <td className='p-2'>{formatDate(cheque.deadline)}</td>
                                <td className='p-2'>{cheque.serialNumber} </td>
                                <td className='p-2'>{cheque.sentTo} </td>
                                <td className='p-2 items-center'>

                                    <div className='flex gap-x-3'>
                                        {
                                            searchParams.isEnabled &&
                                            <>
                                                <span className='cursor-pointer hover:scale-125 hover:text-blue-600 duration-150' onClick={() => nav(`/cheque/edit/${cheque.id}`)}>
                                                    <AiFillEdit />
                                                </span>
                                                <span
                                                    className='cursor-pointer hover:scale-125 hover:text-red-600 duration-150'
                                                    onClick={() => {
                                                        setIsOpen(true)
                                                        setDeleteId(cheque.id)
                                                    }}
                                                >
                                                    <AiFillDelete />
                                                </span>
                                            </>

                                        }
                                    </div>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
            <LoadMore page={chequePage} pending={pendingApiCall} onLoadMore={onLoadMore} />
            <DeleteModal
                isOpen={isOpen}
                closeModal={() => setIsOpen(false)}
                onClick={onClickDelete}
                pendingApiCall={pendingApiCallDelete}
            />
        </div>
    )
}

export default ChequeListPage